import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M18,3 C18,2.448 17.552,2 17,2 L3,2 C2.448,2 2,2.448 2,3 L2,17 C2,17.552 2.448,18 3,18 L17,18 C17.552,18 18,17.552 18,17 L18,3 Z M20,2 L20,18 C20,19.105 19.105,20 18,20 L2,20 C0.895,20 0,19.105 0,18 L0,2 C0,0.895 0.895,0 2,0 L18,0 C19.105,0 20,0.895 20,2 L20,2 Z M14.021,7.015 C14.412,7.405 14.412,8.039 14.021,8.429 L10.133,12.317 C9.546,12.903 8.596,12.903 8.009,12.317 L6.242,10.55 C5.852,10.16 5.852,9.527 6.242,9.136 C6.633,8.746 7.266,8.746 7.656,9.136 L8.362,9.842 C8.753,10.233 9.388,10.233 9.78,9.842 L12.607,7.015 C12.997,6.624 13.631,6.624 14.021,7.015 L14.021,7.015 Z"
      id="path-done"
    />
  </svg>
);
